import type { ReactNode } from "react";
import "./InfoList.css";

export interface InfoListItem {
  label: ReactNode;
  value?: ReactNode;
}

export interface InfoListProps {
  items: InfoListItem[];
  /** shown in grey when a value is missing (default "—") */
  emptyText?: ReactNode;
  /** "row" (default): label left, value right; "stacked": label above the
      value, for narrow cards and side panels */
  layout?: "row" | "stacked";
  className?: string;
}

/**
 * Read-only details as label / value rows.
 * Example: <InfoList items={[{ label: "Email", value: user.email }]} />
 */
const InfoList = ({
  items,
  emptyText = "—",
  layout = "row",
  className = "",
}: InfoListProps) => (
  <dl className={`ds-info-list ds-info-list--${layout} ${className}`.trim()}>
    {items.map((item, i) => {
      const empty =
        item.value === undefined || item.value === null || item.value === "";
      return (
        <div key={i} className="ds-info-list__row">
          <dt className="ds-info-list__label">{item.label}</dt>
          <dd className={`ds-info-list__value ${empty ? "is-empty" : ""}`}>
            {empty ? emptyText : item.value}
          </dd>
        </div>
      );
    })}
  </dl>
);

export default InfoList;
